<template>
  <div class="PageChange">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="pageChange"
      :current-page="pageInfo.pageNumber"
      :page-size="10"
      background
      layout="prev, pager, next"
      :total="200">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'PageChange',
  props: {
    pageInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  methods: {
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`);
      this.pageInfo.pageSize = val
      this.pageInfo.pageFunc(this.pageInfo.pageNumber, this.pageInfo.pageSize)
    },
    pageChange (newIndex) {
      console.log(newIndex)
      // 控制页码
      this.pageInfo.pageNumber = newIndex
      this.pageInfo.pageFunc(this.pageInfo.pageNumber)
    }
  }
}
</script>

<style lang="stylus">
.PageChange
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  .showPage
    span
      margin-left: 10px;
  .el-pagination.is-background
    padding 0
    border 1px solid #07f

    button
      margin 0
      background rgba(22,75,153,.1)
    .btn-prev
      border-right  1px solid #07f
    .el-pager li
      margin 0
      background-color #f4f4f5
      color #606266
      min-width 30px
      border-radius 0px
      border-right  1px solid #07f
      color #BBD4E9
      background rgba(22,75,153,.1)
      &:not(.disabled).active
        background-color: #07f;
        color: #fff;
</style>
